import $http from '@/config/request';

//播放器-pdf
export const getRscPdfImage = params => {
  return $http.post(`/resource/rsc-info/getRscPdfImage`, params);
};

//播放器-video
export const getRscVideo = params => {
  return $http.post(`/video/hls/getUrlByID`, params);
};

export const getRscH5Video = params => {
  return $http.post('/video/hls/getH5UrlByID', params);
};



